import { Pill } from "lucide-react";
import { CARD, supplementsForToday } from "../lib/planner";

export const SupplementsCard = ({ settings, taken = [], onToggle }) => {
  const supplements = supplementsForToday(settings?.supplements || []);
  if (!supplements.length) return null;

  return (
    <div data-testid="supplements-card" className={`${CARD} p-6 sm:p-8`}>
      <div className="flex items-center gap-2 mb-5">
        <Pill className="h-5 w-5 text-stone-400" />
        <h2 className="font-heading text-2xl font-bold text-[#3b2a24] dark:text-stone-100">Supplements</h2>
      </div>
      <div className="space-y-2">
        {supplements.map((s) => {
          const checked = taken.includes(s.name);
          return (
            <button
              key={s.name}
              type="button"
              data-testid={`supplement-${s.name}`}
              onClick={() => onToggle(s.name)}
              className="w-full flex items-center gap-4 py-3 px-2 rounded-2xl hover:bg-stone-50 dark:hover:bg-stone-800 transition-colors text-left"
            >
              <span
                className={`h-6 w-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                  checked ? "bg-stone-800 dark:bg-stone-100 border-stone-800 dark:border-stone-100" : "border-stone-200 dark:border-stone-700"
                }`}
              >
                {checked && <span className="text-stone-50 dark:text-stone-900 text-xs">✓</span>}
              </span>
              <span className={`text-base ${checked ? "text-[#3b2a24] dark:text-stone-100 line-through" : "text-stone-500 dark:text-stone-400"}`}>
                {s.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
